var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCerActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.8,
    height: 22.475,
    viewBox: "0 0 20.8 22.475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.002,
    y1: 0.501,
    x2: 0.989,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3416b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e45f48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.001,
    y1: 0.474,
    x2: 0.997,
    y2: 0.474,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.001,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.006,
    y1: 0.55,
    x2: 0.996,
    y2: 0.55,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cer_active",
    transform: "translate(-1.2 -0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86794",
    "data-name": "\\uD328\\uC2A4 86794",
    d: "M20.6,4.2l.1.7h0a17.828,17.828,0,0,1,.1,2,21.184,21.184,0,0,1-.5,4.4,16.122,16.122,0,0,1-2.5,5.5,17.063,17.063,0,0,1-6.1,5.3l-.3.2-.3-.2A17.973,17.973,0,0,1,5,16.8a16.122,16.122,0,0,1-2.5-5.5,21.192,21.192,0,0,1-.4-4.4,17.828,17.828,0,0,1,.1-2h0l.1-.7c0-.2-.1-.5-.4-.5-.2-.1-.4.1-.5.3l-.1.7h0c0,.1-.1.9-.1,2.2a17.59,17.59,0,0,0,.6,4.6,17.828,17.828,0,0,0,2.6,5.8,17.931,17.931,0,0,0,6.4,5.6l.6.3a.3.3,0,0,0,.4,0l.6-.3a18.84,18.84,0,0,0,6.4-5.6,17.828,17.828,0,0,0,2.6-5.8A18.158,18.158,0,0,0,22,6.9c0-1.3-.1-2.1-.1-2.2h0L21.5,4c0-.2-.3-.4-.5-.4s-.4.3-.4.6Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86795",
    "data-name": "\\uD328\\uC2A4 86795",
    d: "M4.8,3.7l6.7-2,6.8,2.1a.446.446,0,0,0,.6-.3.446.446,0,0,0-.3-.6h0L11.6.8h-.3l-6.8,2a.486.486,0,0,0-.3.6A.419.419,0,0,0,4.8,3.7Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86796",
    "data-name": "\\uD328\\uC2A4 86796",
    d: "M1.5,4.3,11.1,23a.481.481,0,0,0,.6.2c.1,0,.1-.1.2-.2l5.9-10.9h0l3.7-7.8a.447.447,0,0,0-.8-.4h0L17,11.7,11.6,21.9,2.4,3.9a.663.663,0,0,0-.7-.2A.4.4,0,0,0,1.5,4.3Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86797",
    "data-name": "\\uD328\\uC2A4 86797",
    d: "M6.1,12.6H16.8a.4.4,0,0,0,.4-.5.43.43,0,0,0-.4-.4H6.1a.4.4,0,0,0-.4.5c-.1.2.1.4.4.4",
    fill: "url(#linear-gradient-4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerActive);
export default __webpack_public_path__ + "static/media/cer_active.436a03873c8271aade842ee3b91d57f9.svg";
export { ForwardRef as ReactComponent };